export const constants = {
    ReadMore : 'Read more...',
    ReadLess: '...Read less',
    FILTERS_ADD: 'All Filters',
    FILTERS_APPLIED: 'Filters applied',
    CURRENCY_LABEL_DEFAULT: '£',
    PRODUCTS_LOADING: 'Products loading',
    PRODUCTS_LOADED: 'Products loaded',
    BACK_TO_TOP_VISIBLE_HEIGHT: 660,
    imageAssetPath: '//asset1.marksandspencer.com/is/image/mands/'
};




// WEBPACK FOOTER //
// /src/config/constants.js